export const onlyDigits = (v = "") => v.replace(/\D/g, "");

export function maskCnpj(v) {
  const d = onlyDigits(v).slice(0, 14);
  return d
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
}

export function isValidCnpj(v) {
  const d = onlyDigits(v);
  if (d.length !== 14 || /^(\d)\1+$/.test(d)) return false;
  const calc = (base, w) => {
    const r = base.split("").reduce((s, n, i) => s + Number(n) * w[i], 0) % 11;
    return r < 2 ? 0 : 11 - r;
  };
  const w1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  return calc(d.slice(0, 12), w1) === Number(d[12]) && calc(d.slice(0, 13), [6, ...w1]) === Number(d[13]);
}

export function isValidCpf(v) {
  const d = onlyDigits(v);
  if (d.length !== 11 || /^(\d)\1+$/.test(d)) return false;
  for (const n of [9, 10]) {
    let s = 0;
    for (let i = 0; i < n; i++) s += Number(d[i]) * (n + 1 - i);
    if (((s * 10) % 11) % 10 !== Number(d[n])) return false;
  }
  return true;
}

export const maskCpf = (v) =>
  onlyDigits(v).slice(0, 11).replace(/^(\d{3})(\d)/, "$1.$2").replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3").replace(/\.(\d{3})(\d)/, ".$1-$2");

export const maskDoc = (v) => (onlyDigits(v).length > 11 ? maskCnpj(v) : maskCpf(v));
export const docLabel = (tipo) => (tipo === "PF" ? "CPF" : "CNPJ");

export function maskPhone(v) {
  const d = onlyDigits(v).slice(0, 11);
  if (d.length <= 2) return d.length ? `(${d}` : "";
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

export function maskConta(v) {
  const d = onlyDigits(v).slice(0, 13);
  return d.length > 1 ? `${d.slice(0, -1)}-${d.slice(-1)}` : d;
}

export const formatPoints = (n) => Number(n || 0).toLocaleString("pt-BR");

export const formatDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "—";

export function formatElapsed(iso, nowMs) {
  const s = Math.max(0, Math.floor((nowMs - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${String(s % 60).padStart(2, "0")}s`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ${String(m % 60).padStart(2, "0")}m`;
  return `${Math.floor(h / 24)}d ${h % 24}h`;
}

export const REQUEST_STATUS = {
  VALIDANDO_DOCUMENTO: { label: "Validando documento", tone: "blue" },
  DOCUMENTO_RECUSADO: { label: "Documento recusado", tone: "slate" },
  AGUARDANDO_CONSULTA: { label: "Aguardando consulta", tone: "amber" },
  PONTUACAO_DISPONIVEL: { label: "Pontuação enviada", tone: "blue" },
  PONTUACAO_INDISPONIVEL: { label: "Indisponível", tone: "slate" },
  AGENDAMENTO_SOLICITADO: { label: "Agendamento solicitado", tone: "green" },
  RESGATE_SOLICITADO: { label: "Resgate solicitado", tone: "purple" },
  RESGATE_CONCLUIDO: { label: "Resgate concluído", tone: "green" },
};

export const APPT_STATUS = {
  NOVO: { label: "Novo", tone: "blue" },
  AGUARDANDO_CONTATO: { label: "Aguardando contato", tone: "amber" },
  CONTATO_REALIZADO: { label: "Contato realizado", tone: "purple" },
  CONCLUIDO: { label: "Concluído", tone: "green" },
  CANCELADO: { label: "Cancelado", tone: "red" },
};

export const MESSAGE_VARS = ["{nome}", "{cnpj}", "{protocolo}", "{horario}"];

export const renderTemplate = (text, values) =>
  Object.entries(values).reduce((t, [k, v]) => t.split(`{${k}}`).join(v), text || "");
